/**
 * Reusable loading spinner with optional text label.
 * Sizes: 'sm' | 'md' (default) | 'lg'
 */
export function LoadingSpinner ({ text = 'Загрузка...', size = 'md', className = '' }) {
  return (
    <div className={`loading-spinner loading-spinner--${size} ${className}`}>
      <div className="loading-spinner__circle" />
      {text && <span className="loading-spinner__text">{text}</span>}
    </div>
  );
}
